function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}><path d="M27.314 4.686C24.294 1.666 20.274 0 16 0S7.708 1.664 4.686 4.686C1.666 7.706 0 11.726 0 16s1.664 8.292 4.686 11.314C7.706 30.334 11.726 32 16 32s8.292-1.664 11.314-4.686C30.334 24.294 32 20.274 32 16s-1.664-8.292-4.686-11.314M28 16c0 2.588-.824 4.987-2.222 6.949L9.051 6.222A11.93 11.93 0 0 1 16 4c6.617 0 12 5.383 12 12M4 16c0-2.588.824-4.987 2.222-6.949l16.727 16.727A11.93 11.93 0 0 1 16 28C9.383 28 4 22.617 4 16" /></svg>;
});